define('plugin/promotion/view/PromotionEmptyView',['require','lib/view/LayoutView'],function (require) {

    var LayoutView = require('lib/view/LayoutView');

    /**
     * Promotion empty view
     *
     * @class PromotionEmptyView
     */
    return LayoutView.extend({

        template: '#promotion_empty_view',

        serializeData: function () {
            return {
                message: 'client_promotion_empty_message'
            };
        }

    });

});
